function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable react/display-name */
import React, { useEffect, memo, useRef, useState, forwardRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { ESCAPE_KEY, TAB_KEYCODE, ARROW_DOWN_KEY } from '../../Utils/constant';
import styles from '@dtsl/css-simple-select/dist/index.module.css';
import { Input } from '@dtsl/react/dist/components/Input';
const SimpleSelectMenu = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    id,
    children,
    style = {},
    searchable = false,
    searchableProps = {},
    noOptionContent = null,
    isMenuOpen,
    setIsMenuOpen,
    className = '',
    ...restProps
  } = props;
  const triggerRef = ref;
  const menuRef = useRef(null);
  const searchRef = useRef(null);
  const [focusedIndex, setFocusedIndex] = useState(0);
  const handleDocumentClick = e => {
    if (menuRef?.current && !menuRef.current?.contains(e.target) && !triggerRef?.current?.contains(e.target)) {
      setIsMenuOpen(false);
    }
  };
  const handleDocumentKeyPress = event => {
    if (event.key === ESCAPE_KEY || event.keyCode === TAB_KEYCODE && searchRef?.current?.contains(event.target) && !searchRef?.current?.nextSibling) {
      isMenuOpen && setIsMenuOpen(isMenuOpen => !isMenuOpen);
    }
    if (event.key === ARROW_DOWN_KEY && (event.target.ariaHasPopup === 'listbox' || searchRef?.current?.contains(event.target))) {
      const list = menuRef?.current?.children[searchable ? 1 : 0]?.children;
      let index = 0;
      //set focus on the first pre-selected option, if nothing is pre-selected than set focus on first option.
      Array.from(list).forEach((option, i) => {
        if (option.ariaSelected === 'true') {
          index = i;
        } else if (option.ariaDisabled === 'true') {
          index = i + 1;
        }
      });
      setFocusedIndex(index);
      list[index].setAttribute('tabIndex', '0');
      list[index].focus();
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleDocumentKeyPress);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
      document.removeEventListener('keydown', handleDocumentKeyPress);
    };
  }, []);
  const menuClasses = classNames({
    [styles['sib-simple-select__panel']]: true,
    [className]: !!className
  });
  const NoOptionContent = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles['sib-simple-select--no-option']
    }, noOptionContent());
  };
  return isMenuOpen ? /*#__PURE__*/React.createElement("div", {
    className: menuClasses,
    ref: menuRef,
    style: style,
    id: `${id}__menu`
  }, searchable && /*#__PURE__*/React.createElement(Input, _extends({
    ref: searchRef
  }, searchableProps, {
    type: "search",
    className: styles['sib-simple-select__search']
  })), /*#__PURE__*/React.createElement("ul", {
    className: styles['sib-simple-select__options'],
    role: "listbox"
  }, children?.length ? React.Children.map(children, child => {
    return /*#__PURE__*/React.cloneElement(child, {
      isMenuOpen,
      setIsMenuOpen,
      focusedIndex,
      setFocusedIndex,
      menuRef,
      triggerRef,
      children,
      ...restProps
    });
  }) : /*#__PURE__*/React.createElement(NoOptionContent, null))) : null;
});
SimpleSelectMenu.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  searchable: PropTypes.bool,
  searchableProps: PropTypes.object,
  noOptionContent: PropTypes.func,
  isMenuOpen: PropTypes.bool,
  setIsMenuOpen: PropTypes.func,
  className: PropTypes.string,
  id: PropTypes.string
};
export default /*#__PURE__*/memo(SimpleSelectMenu);